import { render, staticRenderFns } from "./FromTransactionPopup.vue?vue&type=template&id=b94161f4&scoped=true"
import script from "./FromTransactionPopup.vue?vue&type=script&lang=js"
export * from "./FromTransactionPopup.vue?vue&type=script&lang=js"
import style0 from "./FromTransactionPopup.vue?vue&type=style&index=0&id=b94161f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94161f4",
  null
  
)

export default component.exports